export default "__VITE_ASSET__CDQksWOL__"